module.exports = __webpack_public_path__ + "img/beijing13.35e7b704.png";